import { Base64 } from 'js-base64';
import React, { Fragment, memo, useContext, useState } from "react";
import styled from 'styled-components';
import { _O } from "../../../modules/utils";
import { checkName, stringToTelNo } from '../../../modules/utils/CheckLogic';
import IconPhone from "../../../resources/images/icon/newIcon/Icon awesome-phone.svg";
import Metro from "../../../resources/images/icon/newIcon/metro-location.svg";
import { mapLayer } from "../../common/Modal/NaverMap";
import { openLayerFn } from "../../Layout";
import { AppContext } from './../../../components/AppProvider';
import { PostApi1914 } from './../../../modules/network/padoPost';
import { setCookie } from '../../../modules/utils/cookie';

export default memo((props) => {
    const { searchType, data, setLocationInfo, settingTrgtList, connectEvent } = props;

    return(
        <ContentsDiv>
            <FlexDiv>
                <HospitalInfo data={data} setLocationInfo={setLocationInfo} />
                
                {data.procStat === "01" && <BtnHold data={data} />}
                {data.procStat === "02" && <BtnConnect data={data} isOnParam={data.sharYn === "Y" ? true : false} />}
                {data.procStat === "03" && <BtnRe data={data} />}

            </FlexDiv>
        </ContentsDiv>
    );
})

const HospitalInfo = (props) => {
  const { data, setLocationInfo } = props;
  const { phonecfg } = useContext(AppContext);
  return (
    <div style={{ width: "70%" }}>
      <FlexDiv>
        <ListTitle>
          {checkName(data.hsptNm, 9, 9)} ({data.address2})
        </ListTitle>
        <div>
          <img
            src={Metro}
            onClick={() => mapLayer(phonecfg, setLocationInfo, data)}
            style={{ width: "12px", height: "19px", marginLeft: "8px" }}
          />
        </div>
      </FlexDiv>

      <ListData style={{ width: "70%", wordBreak: "break-all" }}>
        {data.address3} {data.address4}
      </ListData>

      <FlexDiv>
        {data.phone && (
          <Fragment>
            <div>
              <img
                src={IconPhone}
                style={{ width: "10px", height: "10px", marginRight: "8px" }}
              />
            </div>

            <ListData style={{ marginRight: "8px" }}>
              {stringToTelNo(data.phone)}
            </ListData>
          </Fragment>
        )}
      </FlexDiv>

      <FlexDiv>
        {data.hsptSharYn === "N" && (
          <RoundDivPp onClick={() => openLayerFn($(".navi-layer"))}>
            송신제한
          </RoundDivPp>
        )}

        <RoundDivPpFilled>
          {data.profUseYn === "Y" ? "제증명신청가능" : "제증명신청불가"}
        </RoundDivPpFilled>
      </FlexDiv>
    </div>
  );
};

const ListTitle = styled.div`
  text-align: left;
  font: normal normal bold 16px/20px Pretendard;
  letter-spacing: 0px;
  color: #00000099;
`;

const ListData = styled.div`
  text-align: left;
  font: normal normal normal 12px/20px Pretendard;
  font-weight: 600;
  letter-spacing: 0px;
  color: #00000099;
`;

const BtnConnect = (props) => {
  const { data, isOnParam } = props;
  const { userinfo, phonecfg, cfg } = useContext(AppContext);
  const [isOn, setIsOn] = useState(isOnParam);
  const [save, setSave] = useState(false);

  // let isOn = isOnParam;

  const onClickToggle = () => {
    setSave((prev) => !prev);
    setIsOn((prev) => !prev);
  };

  const request1914 = () => {
    PostApi1914(userinfo, cfg, phonecfg, "hpKey", !isOn ? "Y" : "N", data.hpKey)
      .then((res) => {
        if (res.resultCode === "000") {
          setIsOn((prev) => !prev);
          // 병원 등록 후 메인팝업 재노출
          setCookie("showCnntHspt", "", 0);
        }
      })
      .catch((err) => {
        console.log("err:: ", err);
      });
  };

  return (
    <BtnDiv
      style={{ marginLeft: "auto", backgroundColor: isOn ? "#afb8e7" : "#B8B8B8" }}
      onClick={() => request1914()}
    >
      <span className={isOn ? "onoff-btn on" : "onoff-btn off"}>
        <em>
          <u>ON</u>
          <s></s>
          <u>OFF</u>
        </em>
      </span>
    </BtnDiv>
  );
};

const BtnHold = () => {
  const style = {
    width: "70px",
    height: "34px",
    lineHeight: "34px",
    backgroundColor: "#fff",
    borderRadius: "20px",
    textAlign: "center",
    margin: "auto 0 auto auto",
    fontWeight: "600",
    color: "#A5AEE5",
  };
  return <div style={style}>대기중</div>;
};

const BtnRe = ({ data }) => {
  const style = {
    width: "70px",
    height: "34px",
    lineHeight: "34px",
    backgroundColor: "#B8B8B8",
    borderRadius: "20px",
    textAlign: "center",
    margin: "auto 0 auto auto",
    fontWeight: "600",
  };

  const aplnUserInfo = {
    birth: data.aplnBirthDt,
    sex: data.aplnGndr,
    userPhone: data.aplnTelNo,
    userName: data.aplnUserNm,
  };

  return (
    <div
      style={style}
      onClick={() => {
        _O.Open(
          "/updataHsptCnntInfo/" +
            data.hpKey +
            "/" +
            data.hsptNm +
            "/U/" +
            Base64.encode(JSON.stringify(aplnUserInfo))
        );
      }}
    >
      재신청
    </div>
  );
};

const ContentsDiv = styled.div`
  border: 1px solid #0000001f;
  border-radius: 8px;
  padding: 14px 21px;
  margin-bottom: 16px;
`;

const FlexDiv = styled.div`
  display: flex;
`;

const BtnDiv = styled.div`
  background-color: #b8b8b8;
  color: #fff;
  border-radius: 20px;
  // width: 20%;
  width: 70px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  margin: auto 0 auto auto;
`;

const RoundDivPp = styled.div`
  text-align: center;
  font: normal normal bold 8px/10px Pretendard;
  letter-spacing: 0px;
  opacity: 1;
  // background-color: #A5AEE5;
  border: 1px solid #a5aee5;
  border-radius: 20px;
  margin: auto 0px auto 0px;
  // width: 54px;
  padding: 0px 8px;
  margin-right: 4px;
  height: 16px;
  line-height: 16px;
  color: #a5aee5;
`;

const RoundDivPpFilled = styled.div`
  text-align: center;
  font: normal normal bold 8px/10px Pretendard;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  background-color: #a5aee5;
  border-radius: 20px;
  margin: auto 0px auto 0px;
  // width: 54px;
  padding: 0px 8px;
  margin-right: 4px;
  height: 16px;
  line-height: 16px;
`;